import React from "react";
import "./Services.css";

function Services() {
  const services = [
    {
      title: "Développement Web",
      description:
        "Création de sites web modernes et réactifs avec les dernières technologies.",
      icon: "🌐", // Emoji ou icône
    },
    {
      title: "Base de Données",
      description:
        "Conception, optimisation et maintenance de bases de données robustes.",
      icon: "📊",
    },
    {
      title: "Développement d'Application",
      description:
        "Développement d'applications performantes et évolutives pour tous les besoins.",
      icon: "📱",
    },
    {
      title: "Développement Mobile",
      description:
        "Création d'applications mobiles natives et hybrides pour Android et iOS.",
      icon: "📲", // Emoji ou icône
    },
    
  ];

  return (
    <div className="services">
      <h1 className="services-title">Mes Services</h1>
      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-icon">{service.icon}</div>
            <h2 className="service-title">{service.title}</h2>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Services;
